module.exports = __webpack_public_path__ + "img/iStock-1040303976.18b99c08.jpg";